(function ($) {
  $(document).ready(function () {
    $('.scfMultipleLineTextBox').length && $('.scfMultipleLineTextBox').scrollbar();
  });
})(jQuery);